/**
 * 종료일과 기간 프리셋을 기준으로 조회 시작일을 계산합니다.
 *
 * @param {string|Date} endDate - 조회 종료일
 * @param {"week"|"months"|"3months"|"6months"|"years"} preset - 조회 기간
 * @returns {string|null} YYYY-MM-DD 형식의 시작일 또는 잘못된 프리셋인 경우 null
 */
export const calcStartDate = (endDate, preset) => {
  const end = new Date(endDate)
  const start = new Date(end)

  switch (preset) {
    case "week":
      // 종료일을 포함한 최근 7일
      start.setDate(end.getDate() - 6)
      break

    case "months":
      start.setMonth(end.getMonth() - 1)
      start.setDate(start.getDate() + 1)
      break

    case "3months":
      start.setMonth(end.getMonth() - 3)
      start.setDate(start.getDate() + 1)
      break

    case "6months":
      start.setMonth(end.getMonth() - 6)
      start.setDate(start.getDate() + 1)
      break

    case "years":
      start.setMonth(end.getMonth() - 12)
      start.setDate(start.getDate() + 1)
      break

    default:
      return null
  }

  return start.toISOString().slice(0, 10)
}
